export const nameMaxLength = 20;
export const descriptionMaxLength = 300;
export const locationMaxLength = 20;
export const websiteMaxLength = 50;
export const socialMediaHandleMaxLength = 20;
export const emailMaxLength = 50;